// W1-6b — WHAT THE READER SHOWS WHEN A BOOK'S TEXT IS NOT INGESTED YET.
//
// This was a bare italic sentence laid straight over the reader's page, and on the owner's own walk
// it read as the reader being broken: "placeholder text sits over the page image looking broken".
// It is a card now, it names the book, and it says the one thing that actually matters to a member
// standing in front of it — that the rest of the room still works.
//
// Props in, tree out, no state, no hook: the entry requirement for a component a gate can CALL.

// 14-B7d(2): a DEFAULT language, not a required prop, because `r8-leaves.mjs` CALLS this with a
// title and nothing else and reads the English back. The BOOK'S name rides into the sentence as a
// `{title}` token — a member's own book is never house copy, and gluing it in front of a translated
// clause is how a name ends up in the wrong half of a Spanish sentence.
import { t } from "../strings.js";
import { DEFAULT_LANGUAGE } from "../language.js";

export function ReaderPending({ title, language = DEFAULT_LANGUAGE }: { title: string; language?: string }) {
  return (
    <div className="reader__page reader__page--pending">
      <p className="reader__pending-lead">{t(language, "reader.pendingLead")}</p>
      <p className="reader__pending-note">{t(language, "reader.pendingNote", { title })}</p>
    </div>
  );
}
